import { GraphErrors } from './errors';

export type threadCommentErrorType =
  | 'DEFAULT'
  | 'BLACKLISTED_WORDS'
  | 'RATE_LIMIT_EXCEEDED'
  | 'UNAUTHORIZED_REPLY';

export class ThreadCommentError extends GraphErrors {
  constructor(public readonly key: threadCommentErrorType = 'DEFAULT') {
    super(key);
    this.name = 'threadCommentError';
  }
}
